// React
import React, { useState, useEffect } from "react";
import ReactGA from "react-ga";
import Home from "./containers/Home";
// Styles
import "./App.css";

function initializeReactGA() {
  ReactGA.initialize("UA-156942327-2");
  ReactGA.pageview("/homepage");
  ReactGA.pageview(window.location.pathname + window.location.search);
}

initializeReactGA();

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
